import PropTypes from 'prop-types';
import { paramTypes } from '@/components/parameters/fields/fieldTypes';

const PANEL_READONLY = new Set(['data_version']);

const PathwayFields = ({ params, paramSchemas }) => {
  return (
    <div className="grid grid-cols-3 gap-4">
      {paramSchemas
        .filter(paramSchema => paramTypes[paramSchema.type])
        .map(paramSchema => {
          const { name, type } = paramSchema;
          const FieldComponent = paramTypes[type];
          const param = params[name];
          const schema = PANEL_READONLY.has(name) ? { ...paramSchema, editable: false } : paramSchema;
          return (
            param && (
              <div key={name}>
                <FieldComponent name={name} paramSchema={schema} param={param} />
              </div>
            )
          );
        })}
    </div>
  );
};

PathwayFields.propTypes = {
  params: PropTypes.object,
  paramSchemas: PropTypes.arrayOf(PropTypes.object),
};

export default PathwayFields;
